import { Button, Card, Grid, TextField } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { controlOfAllUserInputs } from 'api/meeting';
import { chunkData, getSubjectName, stripHTMLTags } from 'app/utils/appHelpers';
import { CRON_DATA, DECISION_FILE, REVIEWS } from 'app/utils/constants/customConstant';
import { baseFontSize, dshCardHeight } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DshBoxTitle from '../Box/DshBoxTitle';
import LoadingPopUp from '../LoadingPopup';
import ReviewFileListTable from '../Table/ReviewFileListTable';

function AddUpdateReviewCard({ decision, index, addAfterTable, updateAfterTable, handleDelete, setReviewInputStatus, reviewOfTheUser }) {

    const userList = useSelector(state => state.user.data || []);
    const [agendaFileList, setAgendaFileList] = useState([]);
    const [linkList, setLinkList] = useState([]);

    const { authUser } = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [buttonText, setButtonText] = useState("Kaydet");
    const subjectList = useSelector(state => state.subject.data || []);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(false);

    const emptyReview = {
        userId: authUser.id,
        meetingId: currentMeeting.id,
        decisionId: decision.id,
        info: '',
        pdate: new Date()
    };
    const [review, setReview] = useState(reviewOfTheUser === undefined ? emptyReview : reviewOfTheUser);

    useEffect(() => {
        let agendaFiles = [];
        const getAPI = async () => {
            setLoading(true);
            try {


                let data = [];
                const res = await getObjectListByPropertyApi(DECISION_FILE, "decisionId", decision.id)
                data = res.data || [];
                agendaFiles = data.filter(item => item.fileInfo === null || item.fileInfo === "")
                agendaFiles.forEach(element => {
                    const user = userList.find(item => item.id === element.adminUserId);
                    element.user = user;
                });
                setAgendaFileList(agendaFiles);

                let links = [];
                links = data.filter(item => item.fileInfo !== "" && item.ext === "")
                setLinkList(links)

                if (review.id) {
                    await buttonTextChange(1)

                }

            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);
            }

        };
        getAPI();

    }, [decision.id]);



    const buttonTextChange = async (type) => {
        if (type === 1) { // guncelleme
            setButtonText("Güncelle")
            setIsDeleteButtonVisible(true);

        } else if (type === 2) { // ekle
            setButtonText("Kaydet")
            setIsDeleteButtonVisible(false);
        }

    };


    const groupedData = chunkData(agendaFileList, 5);
    const groupedDataLink = chunkData(linkList, 5);

    const handleSave = async () => {

        // En az 3 karakter kontrolü
        if (!review.info || review.info.trim().length < 3) {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Değerlendirmeniz boş kaydedilemez.',
                showConfirmButton: false,
                timer: 2000
            });
            return;
        }

        try {

            if (review.id) { // guncelleme
                let reviewWithoutUser = Object.assign({}, review);
                delete reviewWithoutUser.user;
                reviewWithoutUser.pdate = new Date(); // Add current timestamp
                review.pdate = new Date();
                const result = await putUpdateObjectApi(REVIEWS, reviewWithoutUser);
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Görüşünüz güncellendi.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    updateAfterTable && updateAfterTable({ ...review })

                }


            } else { // ekleme


                const result = await postSaveObjectApi(REVIEWS, review);
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Görüşünüz kaydedildi.',
                        showConfirmButton: false,
                        timer: 1500

                    });
                    review.id = result.data.insertId;
                    setButtonText("Güncelle")
                    setIsDeleteButtonVisible(true)
                    addAfterTable({ id: result.data.insertId, ...review }); // sor????
                }


            }

        } catch (error) {
            console.error('Hata:', error);
        }

        finally {


            if (review.id !== undefined) {
                const result = await controlOfAllUserInputs(review.meetingId, "review");
                if (result.status) {
                    if (result.data === 0) {



                        // hatırlatıcı varsa silme yapılıyor
                        let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", review.meetingId);
                        existingCron = existingCron.data;
                        if (existingCron.length > 0) {
                            for (const item of existingCron) {
                                await deleteObjectApi(CRON_DATA, item.id);
                            }
                        }

                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 2000,
                            title: 'Bu toplantıya ait tüm değerlendirmeler tamamlandı.',
                        })



                    }
                }
            }

        };

    };


    const handleDeleteItem = async (review) => {
        const result = await handleDelete(review)
        if (result.status) {
            setReview(emptyReview)
            setReviewInputStatus(false)

            await buttonTextChange(2)
        }
    };


    const handleChange = name => (e) => {

        setReview({
            ...review,
            [name]: e.target.value
        })
    }


    const secondTitle = review.id !== undefined
        ? "Değerlendirdiniz"
        : "Henüz Değerlendirmediniz";

    return (
        <>
            <LoadingPopUp open={loading} />
            <div style={{ fontSize: baseFontSize }}>


                {!loading && (

                    <Card
                        key={index}
                        sx={{
                            m: 0,
                            p: '10px',
                            marginBottom: 0,
                            minHeight: `${dshCardHeight}`,
                            // height: `${dshPreviousCardHeight}`,
                        }}
                    >
                        <DshBoxTitle secondTitle={secondTitle} color="primary" title={`Gündem Maddesi ${decision.decisionNo}` + " / " + getSubjectName(decision.subjectId, subjectList)} />


                        <Grid container>
                            <Grid item xs={12} md={12} lg={12} sx={{ padding: 1, fontSize: baseFontSize }}>
                                <span style={{ whiteSpace: "pre-line" }}>{stripHTMLTags(decision.agenda)}</span>
                            </Grid>

                            <Grid
                                container
                                marginY={2}
                                marginX={0}
                                spacing={1}
                                rowSpacing={1}
                            >
                                <Grid item xs={11} md={11} lg={11}>
                                    <TextField
                                        variant="outlined"
                                        label="Gündem hakkındaki değerlendirmenizi yazınız..."
                                        multiline
                                        fullWidth
                                        rows={6}
                                        value={review.info}
                                        onChange={handleChange("info")}
                                        InputProps={{
                                            style: { fontSize: baseFontSize },
                                        }}
                                        InputLabelProps={{
                                            style: { fontSize: baseFontSize },
                                        }}
                                    />

                                </Grid>

                                <Grid item xs={6} md={6} lg={1}>
                                    <Button
                                        variant="contained"
                                        size='small'
                                        color="success"
                                        onClick={handleSave}
                                        style={{
                                            maxWidth: "100%",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {buttonText}
                                    </Button>
                                    {isDeleteButtonVisible && (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            size='small'
                                            onClick={() => handleDeleteItem(review)}
                                            style={{
                                                marginTop: "5px",
                                                maxWidth: "100%",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            Sil
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <ReviewFileListTable groupedData={groupedData} borderType={false} />
                            </Grid>

                            {groupedDataLink.length > 0 && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <ReviewFileListTable groupedData={groupedDataLink} borderType={false} dataType='link' />
                                </Grid>
                            )}
                        </Grid>
                    </Card>
                )}
            </div>

        </>

    );
}
export default AddUpdateReviewCard;


